export const SET_HRMS76X_INDEX_DISP = 'SET_HRMS76X_INDEX_DISP'
export const GET_HRMS76X_INDEX_DISP = 'GET_HRMS76X_INDEX_DISP'
export const SET_HRMS76X_COLUMNS = 'SET_HRMS76X_COLUMNS'
export const GET_HRMS76X_COLUMNS = 'GET_HRMS76X_COLUMNS'
export const SET_HRMS76X_LABELS = 'SET_HRMS76X_LABELS'
export const GET_HRMS76X_LABELS = 'GET_HRMS76X_LABELS'
export const RECEIVED_HRMS76X_COLUMNS_LABELS = 'RECEIVED_HRMS76X_COLUMNS_LABELS'
export const SET_HRMS76X_INDEX = 'SET_HRMS76X_INDEX'
export const GET_HRMS76X_INDEX = 'GET_HRMS76X_INDEX'
export const RECEIVED_HRMS76X_INDEX = 'RECEIVED_HRMS76X_INDEX'



// WEBPACK FOOTER //
// ./src/store/modules/hrms76x/mutation-types.js